import { createFileRoute } from "@tanstack/react-router";
import { EscrowContainer } from "@/features/escrow/containers/escrow-container";

export const Route = createFileRoute("/app/settings/organisation/escrow")({
  component: EscrowContainer,
});
